<template>
  <div class="fb-wrapper" ref="fbButton" @click="click" :class="{ 'connected': isConnected }">
    <div class="fb-spinner" :class="{ 'ready': ready }">
      <div class="spinner" v-if="!ready">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>

      <div v-if="ready" class="fb-login-button" data-auth-type="rerequest" data-scope="public_profile,email" data-max-rows="1" data-size="medium" data-button-type="login_with"
           data-show-faces="false" data-auto-logout-link="false" data-use-continue-as="false"></div>
    </div>

    <div class="small text-muted--ss">เราจะไม่โพสต์เนื้อหาใดโดยไม่ได้รับสิทธิ์อนุญาตจากคุณโดยเด็ดขาด</div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'FacebookLogin',
  props: {
    next: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      isConnected: false,
      fbAuth: {},
      ready: false
    }
  },
  created () {
    if (!Vue.config.FB_APP_ID) {
      return
    }
    const t = setInterval(() => {
      if (window.FB) {
        clearInterval(t)
        this.ready = true

        window.FB.init({
          appId: Vue.config.FB_APP_ID,
          cookie: true,
          xfbml: true,
          version: 'v2.10'
        })

        window.FB.Event.subscribe('xfbml.render', () => {
          this.checkLoginStatus()
        })
      }
    }, 500)
  },
  methods: {
    updateFBAuth (authResponse) {
      this.isConnected = true
      this.fbAuth = authResponse
      return this.$store.dispatch('setFacebookAuth', this.fbAuth)
    },
    checkLoginStatus () {
      window.FB.getLoginStatus(resp => {
        if (resp.status === 'connected') {
          this.updateFBAuth(resp.authResponse)
        } else {
          window.FB.Event.subscribe('auth.login', ev => {
            this.updateFBAuth(ev.authResponse).then(() => {
              this.connect()
            })
          })
        }
      })
    },
    connect () {
      const payload = {
        access_token: this.fbAuth.accessToken,
        user_id: this.fbAuth.userID
      }

      this.$modal.show({
        title: 'กำลัง login',
        text: 'รอสักครู่ ...',
        okButton: false
      })
      this.$http.post('fb/connect', payload)
        .then(resp => {
          if (resp.body.token) {
            // Will auto-login this user
            this.$utils.processLoginResponse(resp)
              .then(() => {
                this.$modal.hide()
                this.$store.state.toast.showToast(`คุณได้เข้าสู่ระบบเรียบร้อยแล้ว`, { timeLife: 1200 })
                this.$emit('success')
              })
              .catch(err => {
                console.log(err)
                this.$modal.show({
                  title: 'ผิดพลาด',
                  text: 'ไม่สามารถดึงข้อมูลผู้ใช้ได้ กรุณาลองใหม่อีกครั้ง'
                })
              })
          } else {
            // Will redirect to register page because user is not registered
            // this.$router.push('/user/register')
          }
        })
        .catch(err => {
          console.log(err)
          this.$utils.showCommonError()
        })
    },
    click ($event) {
      if (this.isConnected && this.fbAuth) {
        $event.preventDefault()
        $event.stopPropagation()
        this.connect()
      }
    }
  }
}
</script>

<style scoped>
.fb-wrapper {
  width: 100%;
  cursor: pointer;
}

.small {
  font-size: 68%;
  line-height: 1.5em;
  margin-top: 10px;
  text-align: center;
}

.connected .fb-login-button {
  cursor: pointer;
  pointer-events: none;
}

.fb-spinner {
  background: #4267b2;
  border-radius: 3px;
  color: white;
  height: 50px;
  padding: 6px 6px;
  text-align: center;
}
.fb-spinner.ready {
  height: 50px;
  padding-top: 12px;
}

.spinner {
  display: inline-block;
  width: 50px;
  height: 30px;
  text-align: center;
  font-size: 10px;
  margin: 0 auto;
}

.spinner > div {
  background-color: rgba(255, 255, 255, 1);
  height: 100%;
  width: 6px;
  display: inline-block;

  -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
  animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}

.spinner .rect3 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

.spinner .rect4 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}

.spinner .rect5 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}

@-webkit-keyframes sk-stretchdelay {
  0%, 40%, 100% { -webkit-transform: scaleY(0.4) }
  20% { -webkit-transform: scaleY(1.0) }
}

@keyframes sk-stretchdelay {
  0%, 40%, 100% {
    transform: scaleY(0.4);
    -webkit-transform: scaleY(0.4);
  }  20% {
       transform: scaleY(1.0);
       -webkit-transform: scaleY(1.0);
     }
}

</style>



// WEBPACK FOOTER //
// FacebookLogin.vue?08c28086